__turbopack_context__.v({
  "homeLink": "styles-module__ocp52W__homeLink",
  "imageContainer": "styles-module__ocp52W__imageContainer",
});
